import { render, staticRenderFns } from "./BuscarPrescricao.vue?vue&type=template&id=df507ff2&"
import script from "./BuscarPrescricao.vue?vue&type=script&lang=js&"
export * from "./BuscarPrescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports